export enum DNPrefixStructure {
  NO_PREFIX = 'no_prefix',
  YEAR_4_DIGITS = 'yyyy',
  YEAR_2_DIGITS = 'yy',
  YEAR_4_DIGITS_AND_MONTH_2_DIGITS = 'yyyymm',
  YEAR_2_DIGITS_AND_MONTH_2_DIGITS = 'yymm',
  MONTH_2_DIGITS = 'mm',
}

export interface AccountingJournal {
  id?: number; // 9,
  code: string;
  draft_code: string;
  name: string;
  center_id: number; // 9,
  type: string;
  default_invoice_status: string;
  invoice_code_length: number; // 9,
  number_of_days_for_due_dates: number; // 9,
  total_amount?: number; // 1
  header_text: string; // "2020-05-05",
  footer_text: string; // "2020-05-05",
  external_id: string; // 1
  document_number_prefix_structure: DNPrefixStructure;
  created_at?: string; // "2020-05-05 11:16:46",
  updated_at?: string; // "2020-05-05 11:16:46",
  deleted_at?: string; // null
}